const resumeLink =
  'https://docs.google.com/document/d/1Bg7OWqWE3J7j9HK6Ghga4nFR04sGlljd8-vM0Xyk0Ik/edit?usp=sharing';

export { resumeLink };
